export default __webpack_public_path__ + "static/media/almost_naked.916133c8.jpg";